var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22H17V20H12C7.66 20 4 16.34 4 12C4 7.66 7.66 4 12 4C16.34 4 20 7.66 20 12V13.43C20 14.22 19.29 15 18.5 15C17.71 15 17 14.22 17 13.43V12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C13.38 17 14.64 16.44 15.54 15.53C16.19 16.42 17.31 17 18.5 17C20.47 17 22 15.4 22 13.43V12C22 6.48 17.52 2 12 2ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15Z",
    fill: "#FF9800"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 14,
    height: 14,
    rx: 7,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0013 1.16602C13.7813 1.16602 11.168 3.77935 11.168 6.99935C11.168 10.2193 13.7813 12.8327 17.0013 12.8327C20.2213 12.8327 22.8346 10.2193 22.8346 6.99935C22.8346 3.77935 20.2213 1.16602 17.0013 1.16602ZM17.5846 9.91602H16.418V8.74935H17.5846V9.91602ZM17.5846 7.58268H16.418V4.08268H17.5846V7.58268Z",
    fill: "#FF9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWarning);
export default __webpack_public_path__ + "static/media/email_warning.aa0ee46e837fe3e6a31e90a7b02c244d.svg";
export { ForwardRef as ReactComponent };